import { authSlice } from "store/auth/reducer";

import { activitiesSlice } from "./activities/reducer";
import { assigmentsSlice } from "./assignments/reducer";
import { calendarSlice } from "./calendar/reducer";
import { chatSlice } from "./chat/reducer";
import { companySlice } from "./company/reducer";
import { editorSlice } from "./editor/reducer";
import { meetingsSlice } from "./meetings/reducer";
import { notificationSlice } from "./notifications/reducer";
import { permissionsSlice } from "./permissions/reducer";
import { rolesSlice } from "./roles/reducer";
import { settingsSlice } from "./settings/reducer";
import { tasksSlice } from "./tasks/reducer";
import { usersSlice } from "./users/reducer";
import { videocallSlice } from "./videocall/reducer";
import { votingSlice } from "./voting/reducer";
import { workspacesSlice } from "./workspaces/reducer";

export const reducers = {
  auth: authSlice.reducer,
  meetings: meetingsSlice.reducer,
  permissions: permissionsSlice.reducer,
  roles: rolesSlice.reducer,
  workspaces: workspacesSlice.reducer,
  users: usersSlice.reducer,
  company: companySlice.reducer,
  notifications: notificationSlice.reducer,
  votings: votingSlice.reducer,
  tasks: tasksSlice.reducer,
  assigments: assigmentsSlice.reducer,
  activities: activitiesSlice.reducer,
  settings: settingsSlice.reducer,
  editor: editorSlice.reducer,
  calendar: calendarSlice.reducer,
  videocall: videocallSlice.reducer,
  chat: chatSlice.reducer,
};
